import { CircleCheckBig } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormSignedBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge variant="default">
      <CircleCheckBig />
      <span>{t('component:badge.formSigned')}</span>
    </Badge>
  );
};
